module.exports = __webpack_public_path__ + "static/media/arima-wordmark-white.5e0b2209.png";